import * as Actions from "./constants";
import { put, call, takeEvery } from "redux-saga/effects";
import { login } from "./service";
import Cookies from "js-cookie";
import setAuthToken from "src/utils/setAuthToken";
import jwtDecode from "jwt-decode";

/**
 * Do login success
 */
function* doLoginSuccess(data) {
  const { token, user } = data;
  localStorage.setItem("role", user.role);
  localStorage.setItem("name", user.name);
  localStorage.setItem("email", user.email);
  localStorage.setItem("USERID", user._id);
  const decoded = jwtDecode(token);
  yield put({
    type: Actions.SET_CURRENT_USER,
    payload: { decoded },
  });
  setAuthToken(token);
  Cookies.set("token", token);
}

/**
 * Login saga
 */
function* loginSaga({ postData }) {
  try {
    const { data } = yield call(login, postData);

    yield call(doLoginSuccess, data);
  } catch (error) {
    yield put({
      type: Actions.GET_LOGIN_ERRORS,
      payload: error,
    });
  }
}

/**
 * Logout Saga
 */
function* logoutSaga() {
  try {
    Cookies.remove("token");
    setAuthToken(false);
    yield put({
      type: Actions.SET_CURRENT_USER,
      payload: {},
    });
  } catch (e) {
    // yield call(handleError, e);
  }
}

export default function* authSaga() {
  yield takeEvery(Actions.LOGIN, loginSaga);
  yield takeEvery(Actions.LOGOUT, logoutSaga);
}
